import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { ThemeInterface } from '../../GlobalStyles/theme/index';
import useDebounce from '../../../hooks/useDebounce';
import { StyledFullPageSpinner } from './Spinner';

interface WrapperProps {
    front: boolean;
    show: boolean;
    theme: ThemeInterface;
}

export const StyledPageOverlayWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: hsla(0, 0%, 100%, 0.75);
    z-index: ${(props: WrapperProps) => (props.front ? props.theme.zindexOverlayLoader : -1)};
    opacity: ${(props: WrapperProps) => (props.show ? 1 : 0)};
    transition: opacity 0.25s ease-in-out;
`;

export interface OverlayLoaderProps {
    loading: boolean;
}

export interface DisplayState {
    frontSelf: boolean;
    showSelf: boolean;
    showSpinner: boolean;
}

const OverlayLoader: FC<OverlayLoaderProps> = ({ loading }): ReactElement => {
    // z-index change is + opacity animation duration of 250 & Show Overlay immediately but delay disappearance
    const frontSelf = useDebounce(loading, loading ? 0 : 800);
    const showSelf = useDebounce(loading, loading ? 0 : 550);

    return (
        <StyledPageOverlayWrapper show={showSelf} front={frontSelf}>
            {showSelf && <StyledFullPageSpinner />}
        </StyledPageOverlayWrapper>
    );
};

export default OverlayLoader;
